/*
  Cart drawer expiry timer.
  The mini cart is re-rendered over AJAX on every cart change, so the deadline
  lives in localStorage and the element just re-attaches to it on each render.
*/
(function () {
  var STORE_KEY = 'the4:cart_expiry';

  function readDeadline() {
    try {
      var raw = parseInt(window.localStorage.getItem(STORE_KEY), 10);
      return isNaN(raw) ? null : raw;
    } catch (e) {
      return null;
    }
  }

  function writeDeadline(value) {
    try {
      window.localStorage.setItem(STORE_KEY, value);
    } catch (e) {}
  }

  function clearDeadline() {
    try {
      window.localStorage.removeItem(STORE_KEY);
    } catch (e) {}
  }

  function format(ms) {
    var total = Math.max(0, Math.ceil(ms / 1000));
    var mm = Math.floor(total / 60);
    var ss = total % 60;
    return (mm < 10 ? '0' : '') + mm + ':' + (ss < 10 ? '0' : '') + ss;
  }

  class CartExpiryTimer extends HTMLElement {
    connectedCallback() {
      this.output = this.querySelector('[data-timer-count]');
      this.label = this.querySelector('[data-timer-label]');
      this.itemCount = parseInt(this.dataset.count, 10) || 0;
      this.duration = (parseFloat(this.dataset.minutes) || 10) * 60000;
      this.urgentAt = (parseFloat(this.dataset.urgent) || 1) * 60000;
      this.onEnd = this.dataset.onEnd || 'message';
      this.expiredText = this.dataset.expiredText || '';

      if (this.itemCount < 1) {
        clearDeadline();
        this.hidden = true;
        return;
      }

      this.hidden = false;

      var stored = readDeadline();
      if (stored === null) {
        this.deadline = Date.now() + this.duration;
        writeDeadline(this.deadline);
      } else if (stored <= Date.now()) {
        this.expire();
        return;
      } else {
        this.deadline = stored;
      }

      this.tick();
      this.interval = setInterval(this.tick.bind(this), 1000);

      // Keep tabs in sync when one of them starts/clears the countdown.
      this.onStorage = function (event) {
        if (event.key !== STORE_KEY) return;
        var next = readDeadline();
        if (next) this.deadline = next;
      }.bind(this);
      window.addEventListener('storage', this.onStorage);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      if (this.onStorage) window.removeEventListener('storage', this.onStorage);
    }

    tick() {
      var left = this.deadline - Date.now();
      if (left <= 0) {
        this.expire();
        return;
      }
      this.output.textContent = format(left);
      this.classList.toggle('is--urgent', left <= this.urgentAt);
    }

    expire() {
      clearInterval(this.interval);
      clearDeadline();

      if (this.onEnd === 'restart') {
        this.deadline = Date.now() + this.duration;
        writeDeadline(this.deadline);
        this.classList.remove('is--urgent');
        this.tick();
        this.interval = setInterval(this.tick.bind(this), 1000);
        return;
      }

      this.classList.add('is--expired');
      this.classList.remove('is--urgent');
      if (this.label && this.expiredText) this.label.textContent = this.expiredText;

      if (this.onEnd !== 'clear' || this.clearing) return;
      this.clearing = true;

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root.replace(/\/$/, '') + '/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          this.clearing = false;
        }.bind(this));
    }
  }

  if (!customElements.get('cart-expiry-timer')) {
    customElements.define('cart-expiry-timer', CartExpiryTimer);
  }
})();
